/*!
 * CILSON Firmenkunden-Angebot (Theme-Frontend, 10/2026)
 * Angebotsrechner für Seite "Firmenkunden – Angebot": Positionen aus dem Shop (products.json / <handle>.js / ?view=cil-data),
 * Rechenlogik nach SPEC §1 (Brutto führend), PDF über window.CilsonAngebotPdf (lazy), Kopie per Shopify-Kontaktformular
 * oder Backend (POST {backend_url}/angebot). Plain ES2017, IIFE, kein Framework. Kein innerHTML mit Nutzereingaben.
 * Reine Rechenfunktion testbar: window.CilsonAngebot.berechne(positionen, kunde, cfg) bzw. require() in Node.
 */
(function () {
  'use strict';

  /* ------------------------------------------------------------------ */
  /* Konstanten                                                          */
  /* ------------------------------------------------------------------ */

  var ABSENDER = {
    firma: 'CILSON – Yasin Ciloglu e.K.', inhaber: 'Yasin Ciloglu', strasse: 'Karl-Schneider-Str. 3', plz: '45966',
    ort: 'Gladbeck', land: 'Deutschland', telefon: '+49 174 93 63 893', fax: '+49 209 940 54 933', email: 'info@cilson.de',
    web: 'www.cilson.de', hrb: 'HRA 6420, Amtsgericht Gelsenkirchen', ustid: 'DE299350637'
  };

  var VERSAND_TEXTE = {
    standard: 'Standardversand Deutschland',
    einMeter: 'Paketversand Deutschland (1-m-Ware)',
    gemischt: 'Standardversand + Paketversand Deutschland (2-m- und 1-m-Ware)',
    kostenlos: 'Kostenloser Versand (ab 150 € Warenwert)'
  };

  var LAENDER = {
    DE: 'Deutschland', AT: 'Österreich', CH: 'Schweiz', NL: 'Niederlande', BE: 'Belgien', LU: 'Luxemburg', FR: 'Frankreich',
    IT: 'Italien', PL: 'Polen', CZ: 'Tschechien', DK: 'Dänemark', SE: 'Schweden', ES: 'Spanien', PT: 'Portugal', LI: 'Liechtenstein',
    SK: 'Slowakei', HU: 'Ungarn', SI: 'Slowenien', HR: 'Kroatien', RO: 'Rumänien', BG: 'Bulgarien', GR: 'Griechenland', NO: 'Norwegen',
    FI: 'Finnland', EE: 'Estland', LV: 'Lettland', LT: 'Litauen', IE: 'Irland', GB: 'Vereinigtes Königreich', MT: 'Malta', CY: 'Zypern',
    IS: 'Island', TR: 'Türkei', US: 'USA', CA: 'Kanada', AU: 'Australien'
  };

  var STANDARD_VPE = [
    { handle: 'cilson-elektro-leerrohr-m16-grau-ral-7035', min: 50, prozent: 3 },
    { handle: 'cilson-elektro-leerrohr-m20-grau-ral-7035', min: 50, prozent: 3 },
    { handle: 'cilson-elektro-leerrohr-m25-grau-ral-7035', min: 25, prozent: 3 },
    { handle: 'cilson-elektro-leerrohr-m32-grau-ral-7035', min: 25, prozent: 3 }
  ];

  var SS_POS = 'cil_angebot_pos';
  var SS_KUNDE = 'cil_angebot_kunde';
  var SS_LETZTES = 'cil_angebot_letztes';
  var SS_KOPIE = 'cil_angebot_kopie_offen';

  /* ------------------------------------------------------------------ */
  /* Geld & Format                                                       */
  /* ------------------------------------------------------------------ */

  function round2(x) {
    if (!isFinite(x)) return 0;
    var s = x < 0 ? -1 : 1;
    return Math.round((x + Number.EPSILON * s) * 100) / 100;
  }

  function formatEuro(n) {
    if (n === null || n === undefined || !isFinite(n)) return '–';
    var neg = n < 0;
    var cents = Math.round(Math.abs(n) * 100);
    var euro = Math.floor(cents / 100);
    var rest = String(cents % 100);
    if (rest.length < 2) rest = '0' + rest;
    var t = String(euro).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return (neg ? '−' : '') + t + ',' + rest + ' €';
  }

  function zahl(v, fallback) {
    if (typeof v === 'number' && isFinite(v)) return v;
    if (typeof v === 'string') {
      var s = v.trim().replace(/\s/g, '').replace(/\.(?=\d{3}(\D|$))/g, '').replace(',', '.');
      if (/^-?\d+(\.\d+)?$/.test(s)) return Number(s);
    }
    return fallback;
  }

  function pad2(n) { return (n < 10 ? '0' : '') + n; }

  function isoLokal(d) {
    var off = -d.getTimezoneOffset();
    var sign = off >= 0 ? '+' : '-';
    off = Math.abs(off);
    return d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate()) + 'T' + pad2(d.getHours()) + ':' + pad2(d.getMinutes()) + ':' + pad2(d.getSeconds()) + sign + pad2(Math.floor(off / 60)) + ':' + pad2(off % 60);
  }

  function datumIso(d) { return d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate()); }

  function datumDe(iso) {
    var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso || ''));
    return m ? m[3] + '.' + m[2] + '.' + m[1] : String(iso || '');
  }

  function zufallsNummer(d) {
    var alphabet = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
    var out = '';
    var bytes = new Uint8Array(4);
    if (typeof crypto !== 'undefined' && crypto.getRandomValues) crypto.getRandomValues(bytes);
    else for (var j = 0; j < 4; j++) bytes[j] = Math.floor(Math.random() * 256);
    for (var i = 0; i < 4; i++) out += alphabet[bytes[i] % alphabet.length];
    var jj = String(d.getFullYear()).slice(2);
    return 'ANG-' + jj + pad2(d.getMonth() + 1) + pad2(d.getDate()) + '-' + out;
  }

  function uuid() {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
    var b = new Uint8Array(16);
    if (typeof crypto !== 'undefined' && crypto.getRandomValues) crypto.getRandomValues(b);
    else for (var i = 0; i < 16; i++) b[i] = Math.floor(Math.random() * 256);
    b[6] = (b[6] & 0x0f) | 0x40; b[8] = (b[8] & 0x3f) | 0x80;
    var h = Array.prototype.map.call(b, function (x) { return (x < 16 ? '0' : '') + x.toString(16); }).join('');
    return h.slice(0, 8) + '-' + h.slice(8, 12) + '-' + h.slice(12, 16) + '-' + h.slice(16, 20) + '-' + h.slice(20);
  }

  /* ------------------------------------------------------------------ */
  /* Produkt-Helfer                                                      */
  /* ------------------------------------------------------------------ */

  function titelBereinigen(t) {
    var s = String(t || '').replace(/\s*\|\s*CILSON.*$/i, '').trim();
    var i = s.indexOf(' – ');
    return (i > 0 ? s.slice(0, i) : s).trim();
  }

  function untertitel(t) {
    var s = String(t || '').replace(/\s*\|\s*CILSON.*$/i, '').trim();
    var i = s.indexOf(' – ');
    return i > 0 ? s.slice(i + 3).trim() : '';
  }

  function variantenName(vTitel, produktTitel) {
    var t = String(vTitel || '').trim();
    if (!t || t === 'Default Title') {
      var u = untertitel(produktTitel).split(',')[0].trim();
      return u;
    }
    return t;
  }

  function istZweiMeter(v) {
    var t = String(v.variante || v.title || '').trim().toLowerCase();
    var sku = String(v.sku || '').toUpperCase();
    return t === '2 m' || t === '2m' || /(^|[\s\/])2 m$/.test(t) || sku.indexOf('1X2M') >= 0;
  }

  function istEinMeter(v) {
    var t = String(v.variante || v.title || '').trim().toLowerCase();
    var sku = String(v.sku || '').toUpperCase();
    return /(^|[\s\/])1 m$/.test(t) || t === '1m' || /1X1M$/.test(sku);
  }

  function erreichteStaffel(tiers, menge) {
    var beste = null;
    (tiers || []).forEach(function (t) {
      var min = Number(t.min), p = Number(t.p);
      if (!isFinite(min) || !isFinite(p) || min <= 0 || p < 0) return;
      if (menge >= min && (!beste || min > beste.min)) beste = { min: min, p: round2(p) };
    });
    return beste;
  }

  function naechsteStaffel(tiers, menge) {
    var next = null;
    (tiers || []).forEach(function (t) {
      var min = Number(t.min), p = Number(t.p);
      if (!isFinite(min) || !isFinite(p) || min <= 0) return;
      if (menge < min && (!next || min < next.min)) next = { min: min, p: round2(p) };
    });
    return next;
  }

  /** Stückpreis brutto nach Staffel (alle Varianten außer 1-m-Varianten – im Shop verifiziert: 2-m-Kanal und Leerrohr ja, 1-m-Kanal nein) bzw. VPE-Regel (Handle); der niedrigere gewinnt. */
  function stueckpreis(p, menge, vpe) {
    var liste = round2(p.preis_brutto);
    var erg = { preis: liste, staffel: null, rabatt_art: null };
    if (!istEinMeter(p) && p.tiers && p.tiers.length) {
      var s = erreichteStaffel(p.tiers, menge);
      if (s && s.p < erg.preis) erg = { preis: s.p, staffel: s, rabatt_art: 'staffel' };
    }
    var regel = null;
    (vpe || []).forEach(function (r) { if (!regel && r && r.handle === p.handle) regel = r; });
    if (regel && menge >= Number(regel.min) && Number(regel.prozent) > 0) {
      var pr = round2(liste * (1 - Number(regel.prozent) / 100));
      if (pr < erg.preis) erg = { preis: pr, staffel: { min: Number(regel.min), p: pr }, rabatt_art: 'vpe' };
    }
    return erg;
  }

  function grundpreisText(preisBrutto, mass) {
    if (!mass || !(Number(mass.quantityValue) > 0)) return undefined;
    var ref = Number(mass.referenceValue) || 1;
    var je = round2((preisBrutto / Number(mass.quantityValue)) * ref);
    return je.toFixed(2).replace('.', ',') + ' € / ' + (ref !== 1 ? ref + ' ' : '') + (mass.referenceUnit || '');
  }

  /** USt-IdNr. vereinheitlichen: Großbuchstaben, ohne Leerzeichen/Punkte/Bindestriche (de299 350 637 → DE299350637). */
  function ustidNorm(v) {
    return String(v || '').toUpperCase().replace(/[\s.\-\/]+/g, '');
  }

  function nettoVon(brutto, taxable, satz) {
    return taxable === false ? round2(brutto) : round2(brutto / (1 + satz / 100));
  }

  /* ------------------------------------------------------------------ */
  /* Reine Rechenfunktion (SPEC §1) – testbar                            */
  /* ------------------------------------------------------------------ */

  function normCfg(cfg) {
    cfg = cfg || {};
    var v = cfg.versand || {};
    var std = zahl(v.standard, 14.99), em = zahl(v.einMeter, 6.9);
    return {
      ustSatz: zahl(cfg.ustSatz, 19),
      gueltigkeitTage: Math.max(1, Math.round(zahl(cfg.gueltigkeitTage, 14))),
      versand: {
        standard: std, einMeter: em, gemischt: zahl(v.gemischt, round2(std + em)),
        freibetrag: zahl(v.freibetrag, 150), grenzeStueck: zahl(v.grenzeStueck, 60), grenzeBrutto: zahl(v.grenzeBrutto, 2000),
        textStandard: v.textStandard || VERSAND_TEXTE.standard, text1m: v.text1m || VERSAND_TEXTE.einMeter,
        textGemischt: v.textGemischt || VERSAND_TEXTE.gemischt, textKostenlos: v.textKostenlos || VERSAND_TEXTE.kostenlos
      },
      texte: {
        zahlung: (cfg.texte && cfg.texte.zahlung) || 'Zahlungsbedingungen laut Rechnung.',
        lieferung: (cfg.texte && cfg.texte.lieferung) || 'Versandfertig in der Regel in 1 Werktag ab Lager Gladbeck.',
        hinweis: (cfg.texte && cfg.texte.hinweis) || 'Dieses Angebot ist freibleibend. Es kommt kein Vertrag zustande, bis Sie Ihre offizielle Bestellung übermittelt haben und wir diese bestätigt haben.',
        bestellweg: (cfg.texte && cfg.texte.bestellweg) || 'Ihre offizielle Bestellung (PDF) können Sie unter www.cilson.de/pages/firmenkunden-bestellung hochladen oder an info@cilson.de senden. Bitte geben Sie die Angebotsnummer an.',
        individuell: (cfg.texte && cfg.texte.individuell) || 'Versandkosten für diese Bestellung werden individuell berechnet und Ihnen vor der Auftragsbestätigung mitgeteilt.'
      },
      vpeRegeln: Array.isArray(cfg.vpeRegeln) ? cfg.vpeRegeln : STANDARD_VPE,
      jetzt: cfg.jetzt instanceof Date ? cfg.jetzt : new Date()
    };
  }

  function leer(s) { return s === undefined || s === null || String(s).trim() === ''; }
  function clean(s) { return leer(s) ? '' : String(s).replace(/\s+/g, ' ').trim(); }

  /**
   * berechne(positionen, kunde, cfg) → Angebot (SPEC §2) ohne "nummer".
   * positionen[]: {product_id, variant_id, handle, titel, variante, sku, menge, preis_brutto (Listenpreis), taxable, tiers[], mass{quantityValue,referenceValue,referenceUnit}}
   * kunde: {firma, ansprechpartner, email, telefon?, ustid?, referenz?, bemerkung?, rechnung{strasse,plz,ort,land}, lieferung{firma?,strasse,plz,ort,land}|null}
   * cfg: {ustSatz, gueltigkeitTage, versand{standard,einMeter,gemischt,freibetrag,grenzeStueck,grenzeBrutto,text*}, texte{...}, vpeRegeln[], jetzt}
   */
  function berechne(positionen, kunde, cfgIn) {
    var cfg = normCfg(cfgIn);
    kunde = kunde || {};
    var rechnung = kunde.rechnung || {};
    var lieferung = kunde.lieferung || null;
    var landR = clean(rechnung.land).toUpperCase() || 'DE';
    var landL = lieferung ? (clean(lieferung.land).toUpperCase() || landR) : landR;
    var landAuto = (landR === 'DE' && landL === 'DE');

    var pos = [];
    var summeBrutto = 0, summeStandard = 0, stueck2m = 0, hatStandard = false, hat1m = false;
    (positionen || []).forEach(function (p, i) {
      var menge = Math.max(1, Math.round(zahl(p.menge, 1)));
      var sp = stueckpreis(p, menge, cfg.vpeRegeln);
      var gesamtBrutto = round2(menge * sp.preis);
      var taxable = p.taxable !== false;
      var o = {
        pos: i + 1,
        product_id: p.product_id,
        variant_id: p.variant_id,
        handle: p.handle,
        titel: p.titel,
        variante: p.variante || '',
        sku: p.sku || '',
        menge: menge,
        einheit: 'Stk',
        listenpreis_brutto: round2(p.preis_brutto),
        einzelpreis_brutto: sp.preis,
        einzelpreis_netto: nettoVon(sp.preis, taxable, cfg.ustSatz),
        staffel: sp.staffel,
        gesamt_brutto: gesamtBrutto,
        gesamt_netto: nettoVon(gesamtBrutto, taxable, cfg.ustSatz)
      };
      if (sp.rabatt_art) o.rabatt_art = sp.rabatt_art;
      var gp = grundpreisText(sp.preis, p.mass);
      if (gp) o.grundpreis = gp;
      if (taxable === false) o.steuerfrei = true;
      pos.push(o);

      summeBrutto += gesamtBrutto;
      if (istEinMeter(p)) hat1m = true;
      else {
        hatStandard = true;
        summeStandard += gesamtBrutto;
        if (istZweiMeter(p)) stueck2m += menge;
      }
    });
    summeBrutto = round2(summeBrutto);
    summeStandard = round2(summeStandard);

    var v = cfg.versand;
    var versand;
    var grund = null;
    if (!landAuto) grund = 'ausland';
    else if (stueck2m >= v.grenzeStueck) grund = 'stueck';
    else if (summeBrutto > v.grenzeBrutto) grund = 'wert';
    var nettoV = function (b) { return round2(b / (1 + cfg.ustSatz / 100)); };
    if (grund) versand = { status: 'individuell', brutto: null, netto: null, text: cfg.texte.individuell, grund: grund };
    else if (pos.length === 0) versand = { status: 'berechnet', brutto: 0, netto: 0, text: '', grund: null };
    else if (hatStandard && hat1m) versand = { status: 'berechnet', brutto: round2(v.gemischt), netto: nettoV(v.gemischt), text: v.textGemischt, grund: null };
    else if (hat1m) versand = { status: 'berechnet', brutto: round2(v.einMeter), netto: nettoV(v.einMeter), text: v.text1m, grund: null };
    else if (summeStandard >= v.freibetrag) versand = { status: 'kostenlos', brutto: 0, netto: 0, text: v.textKostenlos, grund: null };
    else versand = { status: 'berechnet', brutto: round2(v.standard), netto: nettoV(v.standard), text: v.textStandard, grund: null };

    var warenNetto = round2(pos.reduce(function (a, p) { return a + p.gesamt_netto; }, 0));
    var warenBrutto = round2(pos.reduce(function (a, p) { return a + p.gesamt_brutto; }, 0));
    var netto = round2(warenNetto + (versand.netto || 0));
    var brutto = round2(warenBrutto + (versand.brutto || 0));

    var jetzt = cfg.jetzt;
    var bis = new Date(jetzt.getTime());
    bis.setDate(bis.getDate() + cfg.gueltigkeitTage);

    var k = {
      firma: clean(kunde.firma), ansprechpartner: clean(kunde.ansprechpartner), email: clean(kunde.email),
      rechnung: { strasse: clean(rechnung.strasse), plz: clean(rechnung.plz), ort: clean(rechnung.ort), land: landR },
      lieferung: lieferung ? { firma: clean(lieferung.firma), strasse: clean(lieferung.strasse), plz: clean(lieferung.plz), ort: clean(lieferung.ort), land: landL } : null
    };
    ['telefon', 'ustid', 'referenz', 'bemerkung'].forEach(function (f) { if (!leer(kunde[f])) k[f] = clean(kunde[f]); });
    if (k.ustid) k.ustid = ustidNorm(k.ustid);
    if (k.lieferung && !k.lieferung.firma) delete k.lieferung.firma;

    return {
      version: 1,
      erstellt: isoLokal(jetzt),
      gueltig_bis: datumIso(bis),
      waehrung: 'EUR',
      land: landL,
      quelle: 'shop-frontend',
      kunde: k,
      positionen: pos,
      summen: {
        waren_netto: warenNetto,
        waren_brutto: warenBrutto,
        netto: netto,
        versand_netto: versand.netto,
        versand_brutto: versand.brutto,
        versand_text: versand.text,
        versand_status: versand.status,
        versand_grund: versand.grund,
        ust_satz: cfg.ustSatz,
        ust: round2(brutto - netto),
        brutto: brutto
      },
      texte: { zahlung: cfg.texte.zahlung, lieferung: cfg.texte.lieferung, hinweis: cfg.texte.hinweis, bestellweg: cfg.texte.bestellweg },
      absender: JSON.parse(JSON.stringify(ABSENDER))
    };
  }

  /** Angebots-JSON für Versand/Speicherung: interne Hilfsfelder entfernen. */
  function exportAngebot(a) {
    var o = JSON.parse(JSON.stringify(a));
    if (o.summen) { delete o.summen.waren_netto; delete o.summen.waren_brutto; delete o.summen.versand_grund; }
    (o.positionen || []).forEach(function (p) { delete p.steuerfrei; });
    return o;
  }

  /** Textfassung (für die Kopie per Kontaktformular). */
  function textfassung(a) {
    var L = [];
    var k = a.kunde || {};
    L.push('CILSON Firmenkunden-Angebot ' + (a.nummer || ''));
    L.push('Erstellt: ' + datumDe(a.erstellt) + ' · Gültig bis: ' + datumDe(a.gueltig_bis) + ' · Quelle: ' + (a.quelle || ''));
    L.push('');
    L.push('Firma: ' + (k.firma || ''));
    L.push('Ansprechpartner: ' + (k.ansprechpartner || ''));
    L.push('E-Mail: ' + (k.email || '') + (k.telefon ? ' · Telefon: ' + k.telefon : ''));
    if (k.ustid) L.push('USt-IdNr.: ' + k.ustid);
    if (k.referenz) L.push('Referenz: ' + k.referenz);
    var r = k.rechnung || {};
    L.push('Rechnungsanschrift: ' + [r.strasse, (r.plz || '') + ' ' + (r.ort || ''), LAENDER[r.land] || r.land].filter(Boolean).join(', '));
    if (k.lieferung) {
      var l = k.lieferung;
      L.push('Lieferanschrift: ' + [l.firma, l.strasse, (l.plz || '') + ' ' + (l.ort || ''), LAENDER[l.land] || l.land].filter(Boolean).join(', '));
    }
    if (k.bemerkung) L.push('Bemerkung: ' + k.bemerkung);
    L.push('');
    L.push('Positionen:');
    (a.positionen || []).forEach(function (p) {
      var st = p.staffel ? ' (Rabatt ab ' + p.staffel.min + ' Stk: ' + formatEuro(p.staffel.p) + ' brutto' + (p.rabatt_art === 'vpe' ? ', VPE' : '') + ')' : '';
      L.push(p.pos + '. ' + p.titel + (p.variante ? ' – ' + p.variante : '') + ' | Var.-ID ' + p.variant_id + (p.sku ? ' | Art.-Nr. ' + p.sku : '') +
        ' | ' + p.menge + ' Stk × ' + formatEuro(p.einzelpreis_netto) + ' netto (' + formatEuro(p.einzelpreis_brutto) + ' brutto)' + st +
        ' = ' + formatEuro(p.gesamt_netto) + ' netto / ' + formatEuro(p.gesamt_brutto) + ' brutto');
    });
    L.push('');
    var s = a.summen || {};
    L.push('Warenwert netto: ' + formatEuro(round2((s.netto || 0) - (s.versand_netto || 0))));
    if (s.versand_status === 'individuell') L.push('Versand: wird individuell berechnet');
    else L.push('Versand: ' + formatEuro(s.versand_netto) + ' netto / ' + formatEuro(s.versand_brutto) + ' brutto (' + (s.versand_text || '') + ')');
    L.push('Zwischensumme netto: ' + formatEuro(s.netto));
    L.push('USt ' + (s.ust_satz || 19) + ' %: ' + formatEuro(s.ust));
    L.push('Gesamt brutto: ' + formatEuro(s.brutto));
    L.push('Versandstatus: ' + (s.versand_status || ''));
    L.push('');
    L.push('---JSON---');
    L.push(JSON.stringify(exportAngebot(a)));
    return L.join('\n');
  }

  var api = {
    berechne: berechne, round2: round2, formatEuro: formatEuro, istZweiMeter: istZweiMeter, istEinMeter: istEinMeter,
    erreichteStaffel: erreichteStaffel, stueckpreis: stueckpreis, titelBereinigen: titelBereinigen, variantenName: variantenName,
    textfassung: textfassung, exportAngebot: exportAngebot, zufallsNummer: zufallsNummer, ustidNorm: ustidNorm, STANDARD_VPE: STANDARD_VPE, ABSENDER: ABSENDER, LAENDER: LAENDER
  };
  var root = typeof window !== 'undefined' ? window : (typeof globalThis !== 'undefined' ? globalThis : {});
  root.CilsonAngebot = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;

  if (typeof document === 'undefined') return;

  /* ------------------------------------------------------------------ */
  /* DOM-Helfer                                                          */
  /* ------------------------------------------------------------------ */

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function el(tag, attrs, children) {
    var n = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      var v = attrs[k];
      if (v === null || v === undefined || v === false) return;
      if (k === 'class') n.className = v;
      else if (k === 'text') n.textContent = v;
      else if (k.indexOf('on') === 0 && typeof v === 'function') n.addEventListener(k.slice(2), v);
      else if (k === 'value') n.value = v;
      else if (k === 'checked' || k === 'disabled' || k === 'selected' || k === 'hidden') n[k] = !!v;
      else n.setAttribute(k, v === true ? '' : v);
    });
    (children || []).forEach(function (c) {
      if (c === null || c === undefined || c === false) return;
      n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
    });
    return n;
  }

  function clear(n) { while (n && n.firstChild) n.removeChild(n.firstChild); return n; }
  function setText(n, t) {
    if (!n) return;
    var s = t === undefined || t === null ? '' : String(t);
    if (n.textContent !== s) n.textContent = s; // unveränderte aria-live-Bereiche nicht erneut ansagen
  }

  function ssGet(key) { try { var v = sessionStorage.getItem(key); return v ? JSON.parse(v) : null; } catch (e) { return null; } }
  function ssSet(key, val) { try { if (val === null || val === undefined) sessionStorage.removeItem(key); else sessionStorage.setItem(key, JSON.stringify(val)); } catch (e) { /* privat/voll */ } }

  function fetchJson(url, opts) {
    return fetch(url, Object.assign({ credentials: 'same-origin', headers: { Accept: 'application/json' } }, opts || {})).then(function (r) {
      if (!r.ok) { var e = new Error('HTTP ' + r.status); e.status = r.status; throw e; }
      return r.json();
    });
  }

  function bildUrl(src, w) {
    if (!src) return '';
    var s = String(src);
    if (s.indexOf('//') === 0) s = 'https:' + s;
    if (/[?&]width=/.test(s)) return s;
    return s + (s.indexOf('?') >= 0 ? '&' : '?') + 'width=' + (w || 96);
  }

  /* ------------------------------------------------------------------ */
  /* Initialisierung                                                     */
  /* ------------------------------------------------------------------ */

  var rootEl = $('#cil-angebot');
  if (!rootEl) return;

  var cfgEl = $('#cil-angebot-config');
  var S = {};
  try { S = JSON.parse(cfgEl ? cfgEl.textContent : '{}') || {}; } catch (e) { S = {}; }

  var vpeRegeln = STANDARD_VPE;
  if (!leer(S.rabattregeln_json)) {
    try {
      var parsed = JSON.parse(S.rabattregeln_json);
      if (Array.isArray(parsed)) vpeRegeln = parsed.filter(function (r) { return r && typeof r.handle === 'string' && isFinite(Number(r.min)) && isFinite(Number(r.prozent)); })
        .map(function (r) { return { handle: r.handle, min: Number(r.min), prozent: Number(r.prozent) }; });
    } catch (e) { /* Standardregeln behalten */ }
  }

  var CFG = {
    ustSatz: 19,
    gueltigkeitTage: zahl(S.gueltigkeit_tage, 14),
    versand: {
      standard: zahl(S.versand_standard, 14.99), einMeter: zahl(S.versand_1m, 6.9),
      freibetrag: zahl(S.freibetrag, 150), grenzeStueck: zahl(S.grenze_stueck, 60), grenzeBrutto: zahl(S.grenze_brutto, 2000)
    },
    texte: { zahlung: S.text_zahlung, lieferung: S.text_lieferung, hinweis: S.text_hinweis, bestellweg: S.text_bestellweg, individuell: S.text_individuell },
    vpeRegeln: vpeRegeln
  };
  var BACKEND = clean(S.backend_url).replace(/\/+$/, '');
  var UPLOAD_URL = clean(S.upload_url) || '/pages/firmenkunden-bestellung';
  var KOPIE = S.kopie_per_kontaktformular !== false;

  /* Elemente */
  var E = {
    grid: $('#cil-fk-grid'), lock: $('#cil-fk-lock'), lockLink: $('#cil-fk-lock-link'),
    q: $('#cil-fk-q'), qState: $('#cil-fk-q-state'), results: $('#cil-fk-results'),
    empty: $('#cil-fk-empty'), tablewrap: $('#cil-fk-tablewrap'), rows: $('#cil-fk-rows'), posMsg: $('#cil-fk-pos-msg'),
    cartBtns: $$('[data-fk-cart]'),
    form: $('#cil-fk-form'), formAlert: $('#cil-fk-form-alert'),
    abw: $('#fk-abw'), abwBox: $('#fk-abw-box'), land: $('#fk-land'), landSonst: $('#fk-land-sonst-box'), lLand: $('#fk-l-land'), lLandSonst: $('#fk-l-land-sonst-box'),
    ausland: $('#cil-fk-ausland'),
    sum: $('#cil-fk-sum'), sWaren: $('#fk-s-waren'), sVersand: $('#fk-s-versand'), sVersandT: $('#fk-s-versand-t'), sVersandRow: $('#fk-s-versand-row'),
    sNetto: $('#fk-s-netto'), sUst: $('#fk-s-ust'), sBrutto: $('#fk-s-brutto'), sBis: $('#fk-s-bis'), sHint: $('#fk-s-hint'), sCount: $('#fk-s-count'),
    create: $('#cil-fk-create'), status: $('#cil-fk-status'), fine: $('#cil-fk-fine'),
    done: $('#cil-fk-done'), dNummer: $('#fk-d-nummer'), dDatei: $('#fk-d-datei'), dBis: $('#fk-d-bis'), dDown: $('#fk-d-down'), dUpload: $('#fk-d-upload'),
    dNeu: $('#fk-d-neu'), dStatus: $('#fk-d-status'),
    kopieForm: $('#cil-angebot-kopie'),
    steps: $$('#cil-fk-steps li')
  };

  /* Währung prüfen */
  var waehrung = (root.Shopify && root.Shopify.currency && root.Shopify.currency.active) || S.waehrung || 'EUR';
  if (String(waehrung).toUpperCase() !== 'EUR') {
    if (E.lock) E.lock.hidden = false;
    if (E.grid) { E.grid.setAttribute('inert', ''); }
    if (E.lockLink) {
      if ($('#FooterCountryForm')) E.lockLink.setAttribute('href', '#FooterCountryForm');
      else E.lockLink.parentNode.replaceChild(document.createTextNode(E.lockLink.textContent), E.lockLink);
    }
    return;
  }

  /* ------------------------------------------------------------------ */
  /* Zustand                                                             */
  /* ------------------------------------------------------------------ */

  var state = {
    positionen: [],
    katalog: null,          // Array products.json
    katalogPromise: null,
    produkte: {},           // handle → Promise<{js, tiers}>
    letztes: null,          // {angebot, bytes, dateiname}
    busy: false
  };

  /* ------------------------------------------------------------------ */
  /* Produktdaten                                                        */
  /* ------------------------------------------------------------------ */

  function ladeKatalog() {
    if (state.katalog) return Promise.resolve(state.katalog);
    if (state.katalogPromise) return state.katalogPromise;
    setText(E.qState, 'Produkte werden geladen …');
    var alle = [];
    var seite = function (n) {
      return fetchJson('/collections/all/products.json?limit=250&page=' + n).then(function (d) {
        var ps = (d && d.products) || [];
        alle = alle.concat(ps);
        if (ps.length >= 250 && n < 10) return seite(n + 1);
        return alle;
      });
    };
    state.katalogPromise = seite(1).then(function (list) {
      state.katalog = list.map(function (p) {
        var titel = titelBereinigen(p.title);
        var sub = untertitel(p.title);
        var vs = (p.variants || []).map(function (v) {
          return { id: v.id, title: v.title, sku: v.sku || '', price: zahl(v.price, 0), available: v.available !== false };
        });
        var hay = [titel, sub, p.handle, p.product_type].concat(vs.map(function (v) { return v.sku + ' ' + v.title; })).join(' ');
        return { id: p.id, handle: p.handle, titel: titel, sub: sub, bild: p.images && p.images[0] ? p.images[0].src : '', varianten: vs, hay: normSuch(hay) };
      });
      setText(E.qState, '');
      return state.katalog;
    }).catch(function (e) {
      state.katalogPromise = null;
      setText(E.qState, 'Produktliste konnte nicht geladen werden. Bitte Seite neu laden.');
      throw e;
    });
    return state.katalogPromise;
  }

  function normSuch(s) {
    return String(s || '').toLowerCase()
      .replace(/×/g, 'x').replace(/(\d)\s*x\s*(\d)/g, '$1x$2')
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
      .replace(/[^a-z0-9.\-\/ ]+/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function ladeProdukt(handle) {
    if (state.produkte[handle]) return state.produkte[handle];
    var pJs = fetchJson('/products/' + encodeURIComponent(handle) + '.js');
    // Hinweis: ohne Accept: application/json – sonst liefert Shopify das Standard-Produkt-JSON statt der view "cil-data" (Staffeln fehlen dann).
    var pData = fetchJson('/products/' + encodeURIComponent(handle) + '?view=cil-data', { headers: { Accept: 'text/html,*/*' } }).catch(function () { return { tiers: [] }; });
    state.produkte[handle] = Promise.all([pJs, pData]).then(function (r) {
      var tiers = (r[1] && Array.isArray(r[1].tiers)) ? r[1].tiers : [];
      return { js: r[0], tiers: tiers };
    }).catch(function (e) { delete state.produkte[handle]; throw e; });
    return state.produkte[handle];
  }

  function positionAus(pd, variantId, menge) {
    var js = pd.js;
    var v = null;
    (js.variants || []).forEach(function (x) { if (!v && String(x.id) === String(variantId)) v = x; });
    if (!v) v = js.variants && js.variants[0];
    if (!v) return null;
    var upm = v.unit_price_measurement || null;
    var mass = upm && Number(upm.quantity_value) > 0 ? { quantityValue: Number(upm.quantity_value), referenceValue: Number(upm.reference_value) || 1, referenceUnit: upm.reference_unit || '' } : null;
    return {
      product_id: js.id, variant_id: v.id, handle: js.handle, titel: titelBereinigen(js.title), untertitel: untertitel(js.title),
      variante: variantenName(v.title, js.title), vtitel: v.title, sku: v.sku || '', menge: Math.max(1, Math.round(zahl(menge, 1))),
      preis_brutto: round2(Number(v.price) / 100), taxable: v.taxable !== false, available: v.available !== false,
      tiers: pd.tiers || [], mass: mass, bild: js.featured_image || '',
      varianten: (js.variants || []).map(function (x) { return { id: x.id, title: x.title, sku: x.sku || '', price: round2(Number(x.price) / 100), available: x.available !== false }; })
    };
  }

  /* ------------------------------------------------------------------ */
  /* Positionen                                                          */
  /* ------------------------------------------------------------------ */

  function speicherePos() {
    ssSet(SS_POS, state.positionen.map(function (p) { var o = Object.assign({}, p); return o; }));
  }

  function hinzufuegen(p) {
    if (!p) return;
    var vorhanden = null;
    state.positionen.forEach(function (x) { if (String(x.variant_id) === String(p.variant_id)) vorhanden = x; });
    if (vorhanden) vorhanden.menge = Math.min(9999, vorhanden.menge + p.menge);
    else state.positionen.push(p);
    speicherePos();
    renderAlles();
  }

  function entfernen(idx) {
    state.positionen.splice(idx, 1);
    speicherePos();
    renderAlles();
    if (E.q) E.q.focus();
  }

  function posMeldung(text, art) {
    if (!E.posMsg) return;
    E.posMsg.className = 'cil-fk-msg' + (art ? ' is-' + art : '');
    setText(E.posMsg, text);
  }

  function addByHandle(handle, variantId, menge) {
    return ladeProdukt(handle).then(function (pd) {
      var p = positionAus(pd, variantId, menge);
      if (!p) throw new Error('Variante nicht gefunden');
      hinzufuegen(p);
      return p;
    });
  }

  function addByVariantId(variantId, menge) {
    return ladeKatalog().then(function (kat) {
      var hit = null;
      kat.forEach(function (p) { p.varianten.forEach(function (v) { if (!hit && String(v.id) === String(variantId)) hit = p; }); });
      if (!hit) throw new Error('Artikel nicht gefunden');
      return addByHandle(hit.handle, variantId, menge);
    });
  }

  function warenkorbUebernehmen() {
    posMeldung('Warenkorb wird gelesen …');
    return fetchJson('/cart.js').then(function (cart) {
      var items = (cart && cart.items) || [];
      if (!items.length) { posMeldung('Ihr Warenkorb ist leer.', 'error'); return; }
      var ketten = items.map(function (it) {
        return ladeProdukt(it.handle).then(function (pd) { return positionAus(pd, it.variant_id, it.quantity); }).catch(function () { return null; });
      });
      return Promise.all(ketten).then(function (ps) {
        var n = 0;
        ps.forEach(function (p) { if (p) { hinzufuegen(p); n++; } });
        posMeldung(n ? n + (n === 1 ? ' Position' : ' Positionen') + ' aus dem Warenkorb übernommen.' : 'Warenkorb konnte nicht übernommen werden.', n ? 'ok' : 'error');
      });
    }).catch(function () { posMeldung('Warenkorb konnte nicht gelesen werden.', 'error'); });
  }

  /* Preise nach dem Laden aus sessionStorage auffrischen (Shop ist führend) */
  function auffrischen() {
    var handles = {};
    state.positionen.forEach(function (p) { handles[p.handle] = true; });
    var jobs = Object.keys(handles).map(function (h) {
      return ladeProdukt(h).then(function (pd) {
        state.positionen.forEach(function (p, i) {
          if (p.handle !== h) return;
          var neu = positionAus(pd, p.variant_id, p.menge);
          if (neu) state.positionen[i] = neu;
        });
      }).catch(function () { /* alte Daten behalten */ });
    });
    return Promise.all(jobs).then(function () { speicherePos(); renderAlles(); });
  }

  /* ------------------------------------------------------------------ */
  /* Rendering: Positionstabelle                                         */
  /* ------------------------------------------------------------------ */

  function renderRows(angebot) {
    clear(E.rows);
    var hat = state.positionen.length > 0;
    if (E.empty) E.empty.hidden = hat;
    if (E.tablewrap) E.tablewrap.hidden = !hat;
    state.positionen.forEach(function (p, i) {
      var ap = angebot.positionen[i];
      var tr = el('tr', { 'data-idx': i });
      tr.appendChild(el('td', { class: 'pos', text: String(i + 1) }));

      var art = el('td', { class: 'art' });
      art.appendChild(el('span', { class: 'cil-fk-art__t', text: p.titel }));
      if (p.varianten && p.varianten.length > 1) {
        var sel = el('select', { class: 'cil-fk-select cil-fk-art__sel', 'aria-label': 'Variante für Position ' + (i + 1) });
        p.varianten.forEach(function (v) {
          var o = el('option', { value: String(v.id), text: v.title + ' – ' + formatEuro(v.price) + ' brutto' + (v.available ? '' : ' (nicht verfügbar)') });
          if (String(v.id) === String(p.variant_id)) o.selected = true;
          sel.appendChild(o);
        });
        sel.addEventListener('change', function () {
          var neuId = sel.value;
          ladeProdukt(p.handle).then(function (pd) {
            var np = positionAus(pd, neuId, p.menge);
            if (!np) return;
            var dup = -1;
            state.positionen.forEach(function (x, j) { if (j !== i && String(x.variant_id) === String(neuId)) dup = j; });
            if (dup >= 0) { state.positionen[dup].menge += np.menge; state.positionen.splice(i, 1); }
            else state.positionen[i] = np;
            speicherePos(); renderAlles();
          });
        });
        art.appendChild(sel);
      } else if (p.variante) {
        art.appendChild(el('span', { class: 'cil-fk-art__v', text: p.variante }));
      }
      if (p.sku) art.appendChild(el('span', { class: 'cil-fk-art__sku', text: 'Art.-Nr. ' + p.sku }));
      if (!p.available) art.appendChild(el('span', { class: 'cil-fk-art__sku', text: 'Derzeit nicht verfügbar – Lieferzeit auf Anfrage.' }));
      tr.appendChild(art);

      var qtd = el('td', { class: 'qty' });
      var qi = el('input', { class: 'cil-fk-input cil-fk-qty', type: 'number', min: '1', max: '9999', step: '1', inputmode: 'numeric', value: String(p.menge), 'aria-label': 'Menge für Position ' + (i + 1) });
      var commit = function () {
        var m = Math.round(zahl(qi.value, p.menge));
        if (!(m >= 1)) m = 1;
        if (m > 9999) m = 9999;
        if (m !== p.menge) { p.menge = m; speicherePos(); renderAlles(); }
        else qi.value = String(m);
      };
      qi.addEventListener('change', commit);
      qi.addEventListener('keydown', function (ev) { if (ev.key === 'Enter') { ev.preventDefault(); commit(); } });
      qtd.appendChild(qi);
      tr.appendChild(qtd);

      var ptd = el('td', { class: 'price num' });
      ptd.appendChild(el('span', { class: 'cil-fk-price__n', text: formatEuro(ap.einzelpreis_netto) }));
      ptd.appendChild(el('span', { class: 'cil-fk-price__b', text: 'brutto ' + formatEuro(ap.einzelpreis_brutto) + (ap.grundpreis ? ' · ' + ap.grundpreis : '') }));
      if (ap.staffel) {
        ptd.appendChild(el('span', { class: 'cil-fk-price__st is-on', text: (ap.rabatt_art === 'vpe' ? 'VPE-Mengenrabatt aktiv' : 'Mengenrabatt aktiv') + ' (statt ' + formatEuro(ap.listenpreis_brutto) + ' brutto)' }));
      } else {
        var next = !istEinMeter(p) ? naechsteStaffel(p.tiers, p.menge) : null;
        var regel = null;
        vpeRegeln.forEach(function (r) { if (!regel && r.handle === p.handle) regel = r; });
        if (next && next.p < ap.einzelpreis_brutto) ptd.appendChild(el('span', { class: 'cil-fk-price__st', text: 'ab ' + next.min + ' Stk ' + formatEuro(next.p) + ' brutto' }));
        else if (regel && p.menge < regel.min) ptd.appendChild(el('span', { class: 'cil-fk-price__st', text: 'ab ' + regel.min + ' Stk −' + regel.prozent + ' % (VPE)' }));
      }
      tr.appendChild(ptd);

      tr.appendChild(el('td', { class: 'sum num', text: formatEuro(ap.gesamt_netto) }));

      var dtd = el('td', { class: 'del' });
      dtd.appendChild(el('button', { type: 'button', class: 'cil-fk-x', 'aria-label': 'Position ' + (i + 1) + ' entfernen', title: 'Entfernen', text: '×', onclick: function () { entfernen(i); } }));
      tr.appendChild(dtd);
      E.rows.appendChild(tr);
    });
  }

  /* ------------------------------------------------------------------ */
  /* Suche                                                               */
  /* ------------------------------------------------------------------ */

  var suchTimer = null;

  function renderResults(list, query) {
    clear(E.results);
    if (!list.length) {
      E.results.hidden = true;
      setText(E.qState, query ? 'Keine Treffer für „' + query + '“.' : '');
      return;
    }
    setText(E.qState, list.length + (list.length === 1 ? ' Treffer' : ' Treffer') + (list.length >= 8 ? ' (bitte Suche eingrenzen)' : ''));
    list.forEach(function (p) {
      var li = el('li', { class: 'cil-fk-result' });
      var img = el('img', { class: 'cil-fk-result__img', alt: '', width: '48', height: '48', loading: 'lazy' });
      if (p.bild) img.src = bildUrl(p.bild, 96);
      li.appendChild(img);
      li.appendChild(el('p', { class: 'cil-fk-result__t', text: p.titel }));
      li.appendChild(el('p', { class: 'cil-fk-result__s', text: p.sub || p.handle }));
      var row = el('div', { class: 'cil-fk-result__row' });
      var sel = null;
      var mehr = p.varianten.length > 1;
      if (mehr) {
        sel = el('select', { class: 'cil-fk-select', 'aria-label': 'Variante: ' + p.titel });
        p.varianten.forEach(function (v) { sel.appendChild(el('option', { value: String(v.id), text: v.title + ' – ' + formatEuro(v.price) + (v.available ? '' : ' (nicht verfügbar)') })); });
        row.appendChild(sel);
      } else {
        var v0 = p.varianten[0];
        row.appendChild(el('span', { class: 'cil-fk-result__single', text: (variantenName(v0 && v0.title, p.titel + (p.sub ? ' – ' + p.sub : '')) || 'Stück') + ' – ' + formatEuro(v0 ? v0.price : 0) + ' brutto' + (v0 && v0.sku ? ' · Art.-Nr. ' + v0.sku : '') }));
      }
      var qi = el('input', { class: 'cil-fk-input', type: 'number', min: '1', max: '9999', step: '1', inputmode: 'numeric', value: '1', 'aria-label': 'Menge: ' + p.titel });
      row.appendChild(qi);
      var btn = el('button', { type: 'button', class: 'cil-fk-btn cil-fk-btn--sm', text: 'Hinzufügen' });
      btn.addEventListener('click', function () {
        var vid = sel ? sel.value : (p.varianten[0] && p.varianten[0].id);
        var m = Math.max(1, Math.round(zahl(qi.value, 1)));
        btn.disabled = true; setText(btn, 'Wird geladen …');
        addByHandle(p.handle, vid, m).then(function (np) {
          posMeldung(np.titel + (np.variante ? ' (' + np.variante + ')' : '') + ' hinzugefügt.', 'ok');
          btn.disabled = false; setText(btn, 'Hinzufügen');
        }).catch(function () {
          posMeldung('Artikel konnte nicht geladen werden.', 'error');
          btn.disabled = false; setText(btn, 'Hinzufügen');
        });
      });
      qi.addEventListener('keydown', function (ev) { if (ev.key === 'Enter') { ev.preventDefault(); btn.click(); } });
      row.appendChild(btn);
      li.appendChild(row);
      E.results.appendChild(li);
    });
    E.results.hidden = false;
  }

  function suchen() {
    var q = normSuch(E.q.value);
    if (!q) { clear(E.results); E.results.hidden = true; setText(E.qState, state.katalog ? '' : E.qState.textContent); return; }
    ladeKatalog().then(function (kat) {
      var tokens = q.split(' ').filter(Boolean);
      var hits = kat.filter(function (p) { return tokens.every(function (t) { return p.hay.indexOf(t) >= 0; }); });
      // Exakte Treffer (Titel beginnt mit Suchwort) nach vorn
      hits.sort(function (a, b) {
        var ai = normSuch(a.titel).indexOf(tokens[0]), bi = normSuch(b.titel).indexOf(tokens[0]);
        return (ai < 0 ? 999 : ai) - (bi < 0 ? 999 : bi);
      });
      renderResults(hits.slice(0, 8), E.q.value.trim());
    }).catch(function () { /* Meldung steht bereits */ });
  }

  if (E.q) {
    E.q.addEventListener('input', function () { clearTimeout(suchTimer); suchTimer = setTimeout(suchen, 120); });
    E.q.addEventListener('focus', function () { ladeKatalog().catch(function () {}); });
    E.q.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter') { ev.preventDefault(); var b = $('.cil-fk-result .cil-fk-btn', E.results); if (b && !E.results.hidden) b.click(); }
      if (ev.key === 'Escape') { E.q.value = ''; suchen(); }
    });
  }
  E.cartBtns.forEach(function (b) { b.addEventListener('click', function () { warenkorbUebernehmen(); }); });

  /* ------------------------------------------------------------------ */
  /* Formular (Firmendaten)                                              */
  /* ------------------------------------------------------------------ */

  var MELDUNGEN = {
    valueMissing: 'Bitte füllen Sie dieses Feld aus.',
    typeMismatchEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein (z. B. einkauf@firma.de).',
    patternPlz: 'Bitte geben Sie eine gültige Postleitzahl ein.',
    tooLong: 'Die Eingabe ist zu lang.'
  };

  function fehlerFuer(input) {
    var v = input.validity;
    if (v.valid) return '';
    if (v.valueMissing) return input.getAttribute('data-msg-missing') || MELDUNGEN.valueMissing;
    if (v.typeMismatch && input.type === 'email') return MELDUNGEN.typeMismatchEmail;
    if (v.patternMismatch) return input.getAttribute('data-msg-pattern') || 'Bitte prüfen Sie das Format.';
    if (v.tooLong) return MELDUNGEN.tooLong;
    return 'Bitte prüfen Sie Ihre Eingabe.';
  }

  function zeigeFehler(input, msg) {
    var errEl = $('#' + input.id + '-err');
    if (msg) { input.setAttribute('aria-invalid', 'true'); if (errEl) { setText(errEl, msg); input.setAttribute('aria-describedby', errEl.id); } }
    else { input.removeAttribute('aria-invalid'); if (errEl) setText(errEl, ''); }
  }

  function aktiveFelder() {
    return $$('input, select, textarea', E.form).filter(function (i) { return !i.disabled && !i.closest('[hidden]'); });
  }

  function validiere(fokus) {
    var erster = null;
    aktiveFelder().forEach(function (i) {
      var msg = fehlerFuer(i);
      zeigeFehler(i, msg);
      if (msg && !erster) erster = i;
    });
    if (E.formAlert) setText(E.formAlert, erster ? 'Bitte prüfen Sie die markierten Felder.' : '');
    if (erster && fokus) { erster.focus(); try { erster.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) { erster.scrollIntoView(); } }
    return !erster;
  }

  function landWert(sel, sonstBox) {
    var v = sel ? sel.value : 'DE';
    if (v === 'ZZ') {
      var txt = sonstBox ? clean(($('input', sonstBox) || {}).value) : '';
      var code = null;
      Object.keys(LAENDER).forEach(function (c) { if (!code && LAENDER[c].toLowerCase() === txt.toLowerCase()) code = c; });
      return code || txt || 'ZZ';
    }
    return v || 'DE';
  }

  function leseKunde() {
    var g = function (id) { var n = $('#' + id); return n ? n.value : ''; };
    var abw = E.abw && E.abw.checked;
    return {
      firma: g('fk-firma'), ansprechpartner: g('fk-ansprechpartner'), email: g('fk-email'), telefon: g('fk-telefon'),
      ustid: g('fk-ustid'), referenz: g('fk-referenz'), bemerkung: g('fk-bemerkung'),
      rechnung: { strasse: g('fk-strasse'), plz: g('fk-plz'), ort: g('fk-ort'), land: landWert(E.land, E.landSonst) },
      lieferung: abw ? { firma: g('fk-l-firma'), strasse: g('fk-l-strasse'), plz: g('fk-l-plz'), ort: g('fk-l-ort'), land: landWert(E.lLand, E.lLandSonst) } : null
    };
  }

  function speichereKunde() {
    var d = {};
    $$('input, select, textarea', E.form).forEach(function (i) { if (i.id) d[i.id] = i.type === 'checkbox' ? i.checked : i.value; });
    ssSet(SS_KUNDE, d);
  }

  function ladeKunde() {
    var d = ssGet(SS_KUNDE);
    if (!d) return;
    Object.keys(d).forEach(function (id) {
      var i = $('#' + id);
      if (!i) return;
      if (i.type === 'checkbox') i.checked = !!d[id]; else i.value = d[id];
    });
  }

  function boxAn(box, on) {
    if (!box) return;
    box.hidden = !on;
    $$('input, select, textarea', box).forEach(function (i) { i.disabled = !on; if (!on) zeigeFehler(i, ''); });
  }

  function toggleAbw() {
    boxAn(E.abwBox, !!(E.abw && E.abw.checked));
    toggleSonst();
  }

  function toggleSonst() {
    boxAn(E.landSonst, !!(E.land && E.land.value === 'ZZ'));
    boxAn(E.lLandSonst, !!(E.lLand && E.lLand.value === 'ZZ' && E.abw && E.abw.checked));
  }

  if (E.form) {
    E.form.addEventListener('submit', function (ev) { ev.preventDefault(); if (E.create) E.create.click(); });
    E.form.addEventListener('input', function (ev) {
      var t = ev.target;
      if (t && t.getAttribute && t.getAttribute('aria-invalid') === 'true') zeigeFehler(t, fehlerFuer(t));
      if (E.formAlert && E.formAlert.textContent && !$('[aria-invalid="true"]', E.form) && E.form.checkValidity()) {
        setText(E.formAlert, '');
        if (E.status && E.status.classList.contains('is-error')) status('');
      }
      speichereKunde();
      renderSummary();
    });
    E.form.addEventListener('change', function (ev) {
      if (ev.target === E.abw) toggleAbw();
      if (ev.target === E.land || ev.target === E.lLand) toggleSonst();
      speichereKunde();
      renderSummary();
    });
    E.form.addEventListener('focusout', function (ev) {
      var t = ev.target;
      if (t && t.id === 'fk-ustid' && t.value) { var u = ustidNorm(t.value); if (u !== t.value) { t.value = u; speichereKunde(); } }
      if (t && t.validity && (t.value !== '' || t.required)) zeigeFehler(t, fehlerFuer(t));
    });
  }

  /* ------------------------------------------------------------------ */
  /* Zusammenfassung                                                     */
  /* ------------------------------------------------------------------ */

  function aktuellesAngebot() {
    return berechne(state.positionen, leseKunde(), CFG);
  }

  function renderSummary() {
    var a = aktuellesAngebot();
    var s = a.summen;
    setText(E.sWaren, formatEuro(s.waren_netto));
    setText(E.sNetto, formatEuro(s.netto));
    setText(E.sUst, formatEuro(s.ust));
    setText(E.sBrutto, formatEuro(s.brutto));
    setText(E.sBis, datumDe(a.gueltig_bis));
    setText(E.sCount, state.positionen.length ? state.positionen.length + (state.positionen.length === 1 ? ' Position' : ' Positionen') : 'keine Positionen');
    if (E.sVersandRow) E.sVersandRow.className = 'cil-fk-sum__row' + (s.versand_status === 'individuell' ? ' is-indiv' : (s.versand_status === 'kostenlos' ? ' is-free' : ''));
    if (s.versand_status === 'individuell') {
      setText(E.sVersand, 'wird individuell berechnet');
      setText(E.sVersandT, s.versand_grund === 'ausland' ? 'Lieferung außerhalb Deutschlands' : (s.versand_grund === 'stueck' ? 'ab ' + CFG.versand.grenzeStueck + ' Stück 2-m-Ware' : 'Warenwert über ' + formatEuro(CFG.versand.grenzeBrutto) + ' brutto'));
    } else if (s.versand_status === 'kostenlos') {
      setText(E.sVersand, 'kostenlos');
      setText(E.sVersandT, s.versand_text);
    } else {
      setText(E.sVersand, state.positionen.length ? formatEuro(s.versand_netto) : '–');
      setText(E.sVersandT, state.positionen.length ? s.versand_text + ' (' + formatEuro(s.versand_brutto) + ' brutto)' : 'Deutschland, nach Warenwert');
    }
    if (E.sHint) setText(E.sHint, s.versand_status === 'individuell' ? CFG.texte.individuell || '' : '');
    if (E.ausland) E.ausland.hidden = s.versand_grund !== 'ausland';
    if (E.create) E.create.disabled = state.busy || state.positionen.length === 0;
    if (!(E.done && !E.done.hidden)) {
      var s1 = state.positionen.length > 0;
      var s2 = s1 && !!(E.form && E.form.checkValidity());
      E.steps.forEach(function (li, i) {
        var done = (i === 0 && s1) || (i === 1 && s2);
        li.classList.toggle('is-done', done);
        li.classList.toggle('is-active', (i === 0 && !s1) || (i === 1 && s1 && !s2) || (i === 2 && s2));
      });
    }
    return a;
  }

  function renderAlles() {
    var a = renderSummary();
    renderRows(a);
  }

  /* ------------------------------------------------------------------ */
  /* PDF (lazy)                                                          */
  /* ------------------------------------------------------------------ */

  var pdfModulPromise = null, assetsPromise = null;

  function ladePdfModul() {
    if (root.CilsonAngebotPdf) return Promise.resolve(root.CilsonAngebotPdf);
    if (!pdfModulPromise) {
      pdfModulPromise = new Promise(function (resolve, reject) {
        var A = root.CILSON_PDF_ASSETS || {};
        if (!A.script) { reject(new Error('PDF-Modul nicht konfiguriert')); return; }
        var s = document.createElement('script');
        s.src = A.script; s.charset = 'utf-8'; s.async = true;
        s.onload = function () { root.CilsonAngebotPdf ? resolve(root.CilsonAngebotPdf) : reject(new Error('CilsonAngebotPdf fehlt')); };
        s.onerror = function () { pdfModulPromise = null; reject(new Error('PDF-Modul konnte nicht geladen werden')); };
        document.head.appendChild(s);
      });
    }
    return pdfModulPromise;
  }

  function ladeBytes(url) {
    return fetch(url, { cache: 'force-cache' }).then(function (r) {
      if (!r.ok) throw new Error('Asset ' + url + ': HTTP ' + r.status);
      return r.arrayBuffer();
    }).then(function (b) { return new Uint8Array(b); });
  }

  function ladeAssets() {
    if (!assetsPromise) {
      var A = root.CILSON_PDF_ASSETS || {};
      // Fonts + Logo kommen als Base64-JSON (assets/cilson-pdf-assets.json): der Shopify-CDN liefert .ttf-Assets als WOFF2 aus,
      // das kann das PDF-Modul nicht einbetten. Rückfall: einzelne Dateien (logoPng/fontRegular/fontBold).
      assetsPromise = (A.json ? fetch(A.json, { cache: 'force-cache' }).then(function (r) {
          if (!r.ok) throw new Error('PDF-Assets: HTTP ' + r.status);
          return r.json();
        }).then(function (j) {
          return { logoPng: base64ZuBytes(j.logoPng), fontRegular: base64ZuBytes(j.fontRegular), fontBold: base64ZuBytes(j.fontBold) };
        }) : Promise.all([ladeBytes(A.logoPng), ladeBytes(A.fontRegular), ladeBytes(A.fontBold)])
        .then(function (r) { return { logoPng: r[0], fontRegular: r[1], fontBold: r[2] }; }))
        .catch(function (e) { assetsPromise = null; throw e; });
    }
    return assetsPromise;
  }

  function pdfErzeugen(angebot) {
    return Promise.all([ladePdfModul(), ladeAssets()]).then(function (r) {
      return Promise.resolve(r[0].erstellen(angebot, r[1])).then(function (bytes) {
        return { bytes: bytes, dateiname: r[0].dateiname(angebot) };
      });
    });
  }

  function dateinameLokal(angebot) {
    var firma = String((angebot.kunde && angebot.kunde.firma) || '').split(' – ')[0]
      .replace(/Ä/g, 'Ae').replace(/Ö/g, 'Oe').replace(/Ü/g, 'Ue').replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
      .replace(/[^A-Za-z0-9]+/g, '_').replace(/^_+|_+$/g, '').slice(0, 60);
    return 'CILSON_Angebot_' + angebot.nummer + (firma ? '_' + firma : '') + '.pdf';
  }

  function bytesZuBase64(bytes) {
    var s = '', CH = 0x8000;
    for (var i = 0; i < bytes.length; i += CH) s += String.fromCharCode.apply(null, bytes.subarray(i, i + CH));
    return btoa(s);
  }

  function base64ZuBytes(b64) {
    var bin = atob(String(b64).replace(/\s+/g, ''));
    var out = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
    return out;
  }

  function download(bytes, name) {
    var blob = new Blob([bytes], { type: 'application/pdf' });
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    var kannDownload = 'download' in HTMLAnchorElement.prototype;
    if (kannDownload) {
      a.href = url; a.download = name; a.rel = 'noopener';
      document.body.appendChild(a); a.click(); a.remove();
    } else {
      var w = window.open(url, '_blank');
      if (!w) { a.href = url; a.target = '_blank'; a.rel = 'noopener'; document.body.appendChild(a); a.click(); a.remove(); }
    }
    setTimeout(function () { URL.revokeObjectURL(url); }, 60000);
  }

  /* ------------------------------------------------------------------ */
  /* Kopie per Kontaktformular                                           */
  /* ------------------------------------------------------------------ */

  function kopieSenden(angebot) {
    if (!KOPIE || !E.kopieForm) return Promise.resolve(false);
    var fd = new FormData(E.kopieForm);
    var k = angebot.kunde || {};
    fd.set('contact[email]', k.email || '');
    fd.set('contact[name]', k.firma || '');
    fd.set('contact[body]', textfassung(angebot));
    var action = E.kopieForm.getAttribute('action') || '/contact';
    return fetch(action, { method: 'POST', body: fd, credentials: 'same-origin', redirect: 'follow', headers: { Accept: 'text/html,*/*' } })
      .then(function (r) {
        var u = String(r.url || '');
        // 400 = „Missing CAPTCHA token“ (Shopify-Spamschutz verlangt den Token, den nur ein echtes Formular-Submit erhält), 403 = Bot-Prüfung
        if (r.status === 400 || r.status === 403 || /\/challenge/.test(u)) return 'challenge';
        if (!r.ok) return 'fail';
        return r.text().then(function (t) { return /Verifying your connection|\/challenge|h-?captcha/i.test(t) ? 'challenge' : 'ok'; }, function () { return 'ok'; });
      }).catch(function () { return 'fail'; });
  }

  /* Shopify-Bot-Prüfung hat die Hintergrund-Übermittlung abgewiesen → Formular regulär absenden (Seite lädt neu).
     Angebot (inkl. PDF) liegt vorher in sessionStorage, damit die Fertig-Ansicht nach dem Neuladen wieder erscheint. */
  function kopieNachreichen(angebot) {
    if (!E.kopieForm) return;
    var set = function (name, val) { var f = E.kopieForm.querySelector('[name="' + name + '"]'); if (f) f.value = val; };
    set('contact[email]', (angebot.kunde && angebot.kunde.email) || '');
    set('contact[name]', (angebot.kunde && angebot.kunde.firma) || '');
    set('contact[body]', textfassung(angebot));
    ssSet(SS_KOPIE, { nummer: angebot.nummer, t: Date.now() });
    // Shopify-Spamschutz (hCaptcha): das Formular muss über Shopify.captcha.protect geschützt und per requestSubmit (submit-Event)
    // abgeschickt werden – nur dann hängt Shopify den Captcha-Token an. Ein fetch() oder form.submit() liefert „Missing CAPTCHA token“.
    var absenden = function () {
      try {
        if (typeof E.kopieForm.requestSubmit === 'function') E.kopieForm.requestSubmit(); else E.kopieForm.submit();
      } catch (e) { try { E.kopieForm.submit(); } catch (e2) { ssSet(SS_KOPIE, null); } }
    };
    setTimeout(function () {
      var cap = root.Shopify && root.Shopify.captcha;
      if (cap && typeof cap.protect === 'function') {
        var fired = false;
        var go = function () { if (fired) return; fired = true; absenden(); };
        try { cap.protect(E.kopieForm, go); } catch (e) { go(); }
        setTimeout(go, 4000); // Rückfall, falls der Callback ausbleibt
      } else {
        absenden();
      }
    }, 1600);
  }

  /* ------------------------------------------------------------------ */
  /* Backend                                                             */
  /* ------------------------------------------------------------------ */

  function backendAngebot(angebot, key) {
    var body = exportAngebot(angebot);
    delete body.nummer;
    body.idempotency_key = key;
    return fetch(BACKEND + '/angebot', {
      method: 'POST', credentials: 'same-origin', redirect: 'follow',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return null; }).then(function (j) { return { status: r.status, json: j }; });
    });
  }

  /** 409 preise_geaendert: korrigierte Serverwerte übernehmen (Listenpreis, Staffel); Server ist maßgeblich, kein Storefront-Reload. */
  function korrekturUebernehmen(korr) {
    var sp = (korr && korr.positionen) || [];
    state.positionen.forEach(function (p) {
      var s = null;
      sp.forEach(function (x) { if (!s && String(x.variant_id) === String(p.variant_id)) s = x; });
      if (!s) return;
      if (isFinite(Number(s.listenpreis_brutto))) p.preis_brutto = round2(Number(s.listenpreis_brutto));
      if (s.staffel && s.rabatt_art !== 'vpe' && isFinite(Number(s.staffel.min))) {
        var found = false;
        p.tiers = (p.tiers || []).map(function (t) { if (Number(t.min) === Number(s.staffel.min)) { found = true; return { min: Number(t.min), p: Number(s.staffel.p) }; } return t; });
        if (!found) p.tiers.push({ min: Number(s.staffel.min), p: Number(s.staffel.p) });
      }
    });
    Object.keys(state.produkte).forEach(function (h) { delete state.produkte[h]; });
    speicherePos();
    renderAlles();
  }

  /* ------------------------------------------------------------------ */
  /* Erstellen                                                           */
  /* ------------------------------------------------------------------ */

  function status(text, art) {
    if (!E.status) return;
    E.status.className = 'cil-fk-status' + (art ? ' is-' + art : '');
    setText(E.status, text);
  }

  function setBusy(on) {
    state.busy = on;
    if (E.sum) E.sum.classList.toggle('cil-fk-busy', on);
    if (E.create) { E.create.disabled = on || state.positionen.length === 0; E.create.setAttribute('aria-busy', on ? 'true' : 'false'); }
  }

  function zeigeDone(letztes, hinweise) {
    var a = letztes.angebot;
    if (E.done) E.done.hidden = false;
    if (E.create) E.create.hidden = true;
    if (E.fine) E.fine.hidden = true;
    setText(E.dNummer, a.nummer);
    setText(E.dDatei, letztes.dateiname);
    setText(E.dBis, datumDe(a.gueltig_bis));
    if (E.dUpload) E.dUpload.setAttribute('href', UPLOAD_URL + (UPLOAD_URL.indexOf('?') >= 0 ? '&' : '?') + 'ang=' + encodeURIComponent(a.nummer));
    if (E.dStatus) {
      clear(E.dStatus);
      (hinweise || []).forEach(function (h) {
        E.dStatus.appendChild(el('span', { class: h.art ? 'is-' + h.art : '', text: h.text }));
        E.dStatus.appendChild(el('br'));
        if (h.mailto) {
          var body = textfassung(a);
          if (body.length > 1800) body = body.slice(0, 1800) + '\n…';
          var href = 'mailto:info@cilson.de?subject=' + encodeURIComponent('Angebot ' + a.nummer + ' | ' + (a.kunde.firma || '')) + '&body=' + encodeURIComponent('Sehr geehrtes CILSON-Team,\n\nanbei mein Angebot ' + a.nummer + ' (PDF bitte anhängen).\n\n' + body);
          E.dStatus.appendChild(el('a', { class: 'cil-fk-link', href: href, text: 'Kopie per E-Mail an CILSON senden' }));
          E.dStatus.appendChild(el('br'));
        }
      });
    }
    E.steps.forEach(function (li) { li.classList.add('is-done'); li.classList.remove('is-active'); });
    var pdfB64 = null;
    try { if (letztes.bytes && letztes.bytes.length < 3500000) pdfB64 = bytesZuBase64(letztes.bytes); } catch (e) { pdfB64 = null; }
    ssSet(SS_LETZTES, { nummer: a.nummer, gueltig_bis: a.gueltig_bis, erstellt: a.erstellt, dateiname: letztes.dateiname, kunde: { firma: a.kunde.firma, ansprechpartner: a.kunde.ansprechpartner, email: a.kunde.email }, pdf_b64: pdfB64, positionen: a.positionen || [], summen: a.summen || {} });
    try { E.done.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e) { /* egal */ }
    var h = $('h2', E.done); if (h) { h.setAttribute('tabindex', '-1'); h.focus(); }
  }

  function erstellen() {
    if (state.busy) return;
    if (!state.positionen.length) { status('Bitte fügen Sie zuerst mindestens eine Position hinzu.', 'error'); if (E.q) E.q.focus(); return; }
    if (!validiere(true)) { status('Bitte vervollständigen Sie die Firmendaten.', 'error'); return; }
    status('');
    setBusy(true);
    var angebot = aktuellesAngebot();
    var hinweise = [];
    var key = uuid();
    var ablauf;

    if (BACKEND) {
      status('Angebot wird geprüft …');
      ablauf = backendAngebot(angebot, key).then(function (r) {
        var j = r.json || {};
        if (r.status === 200 && j.ok && j.nummer) {
          var serverA = j.angebot && j.angebot.positionen ? j.angebot : angebot;
          serverA.nummer = j.nummer;
          if (j.gueltig_bis) serverA.gueltig_bis = j.gueltig_bis;
          if (j.erstellt) serverA.erstellt = j.erstellt;
          if (!serverA.absender) serverA.absender = angebot.absender;
          if (!serverA.texte) serverA.texte = angebot.texte;
          hinweise.push({ text: 'Angebot wurde bei CILSON registriert' + (j.mail === 'gesendet' ? ' und eine Kopie an CILSON gesendet.' : '.'), art: 'ok' });
          if (j.pdf_base64) {
            return { angebot: serverA, bytes: base64ZuBytes(j.pdf_base64), dateiname: j.dateiname || dateinameLokal(serverA), quelle: 'server' };
          }
          status('PDF wird erstellt …');
          return pdfErzeugen(serverA).then(function (p) { return { angebot: serverA, bytes: p.bytes, dateiname: j.dateiname || p.dateiname, quelle: 'server-json' }; });
        }
        if (r.status === 409 && j.grund === 'preise_geaendert') {
          var err = new Error('preise_geaendert'); err.korrektur = j.angebot; err.fatal = true; throw err;
        }
        if (r.status === 400 || r.status === 409 || r.status === 413 || r.status === 415 || r.status === 429) {
          var e2 = new Error(j.meldung || ('Die Prüfung ist fehlgeschlagen (' + r.status + ').')); e2.fatal = true; e2.felder = j.felder; throw e2;
        }
        var e3 = new Error('Server nicht erreichbar (' + r.status + ')'); e3.fallback = true; throw e3;
      }).catch(function (e) {
        if (e && e.fatal) throw e;
        // Netzwerk-/Serverfehler → lokaler Modus
        hinweise.push({ text: 'Der CILSON-Server war nicht erreichbar – das Angebot wurde lokal erstellt und eine Kopie per Formular übermittelt.', art: '' });
        return lokalErstellen(angebot, hinweise);
      });
    } else {
      ablauf = lokalErstellen(angebot, hinweise);
    }

    ablauf.then(function (letztes) {
      state.letztes = letztes;
      download(letztes.bytes, letztes.dateiname);
      zeigeDone(letztes, hinweise);
      status('');
      if (letztes.kopieNachreichen && KOPIE) kopieNachreichen(letztes.angebot);
    }).catch(function (e) {
      if (e && e.korrektur) {
        status('Preise wurden aktualisiert – bitte prüfen und erneut erstellen.', 'error');
        posMeldung('Preise wurden aktualisiert – bitte prüfen und erneut erstellen.', 'error');
        return korrekturUebernehmen(e.korrektur);
      }
      var msg = (e && e.message) || 'Unbekannter Fehler';
      if (/PDF/.test(msg)) msg = 'Das PDF konnte nicht erstellt werden (' + msg + '). Bitte versuchen Sie es erneut oder senden Sie uns Ihre Anfrage an info@cilson.de.';
      status(msg, 'error');
    }).then(function () { setBusy(false); });
  }

  function lokalErstellen(angebot, hinweise) {
    angebot.nummer = zufallsNummer(new Date());
    status('PDF wird erstellt …');
    return pdfErzeugen(angebot).then(function (p) {
      var letztes = { angebot: angebot, bytes: p.bytes, dateiname: p.dateiname, quelle: 'lokal' };
      if (!KOPIE) return letztes;
      status('Kopie wird an CILSON übermittelt …');
      return kopieSenden(angebot).then(function (erg) {
        if (erg === 'ok') hinweise.push({ text: 'Kopie an CILSON gesendet.', art: 'ok' });
        else if (erg === 'challenge') { letztes.kopieNachreichen = true; hinweise.push({ text: 'Kopie wird an CILSON übermittelt – die Seite lädt dazu gleich kurz neu.', art: '' }); }
        else hinweise.push({ text: 'Kopie konnte nicht automatisch gesendet werden – Ihr PDF ist davon unabhängig.', art: '', mailto: true });
        return letztes;
      });
    });
  }

  if (E.create) E.create.addEventListener('click', erstellen);
  if (E.dDown) E.dDown.addEventListener('click', function () { if (state.letztes) download(state.letztes.bytes, state.letztes.dateiname); });
  if (E.dNeu) E.dNeu.addEventListener('click', function () {
    state.positionen = []; state.letztes = null; speicherePos();
    if (E.done) E.done.hidden = true;
    if (E.create) E.create.hidden = false;
    if (E.fine) E.fine.hidden = false;
    E.steps.forEach(function (li, i) { li.classList.remove('is-done'); li.classList.toggle('is-active', i === 0); });
    renderAlles();
    if (E.q) E.q.focus();
    try { rootEl.scrollIntoView({ block: 'start', behavior: 'smooth' }); } catch (e) { /* egal */ }
  });

  /* ------------------------------------------------------------------ */
  /* Start: sessionStorage + URL-Parameter                               */
  /* ------------------------------------------------------------------ */

  function doneWiederherstellen() {
    var offen = ssGet(SS_KOPIE);
    var letztesSS = ssGet(SS_LETZTES);
    var meta = document.querySelector('meta[name="cil-kopie"]');
    var posted = !!meta || /^#cil-angebot-kopie/.test(location.hash) || /contact_posted=true/.test(location.search);
    if (!offen || !letztesSS || !posted) { if (offen && Date.now() - (offen.t || 0) > 600000) ssSet(SS_KOPIE, null); return; }
    ssSet(SS_KOPIE, null);
    var ok = !!meta && meta.getAttribute('content') === 'ok';
    var bytes = null;
    try { if (letztesSS.pdf_b64) bytes = base64ZuBytes(letztesSS.pdf_b64); } catch (e) { bytes = null; }
    state.letztes = { angebot: { nummer: letztesSS.nummer, gueltig_bis: letztesSS.gueltig_bis, erstellt: letztesSS.erstellt, kunde: letztesSS.kunde || {} }, bytes: bytes, dateiname: letztesSS.dateiname, quelle: 'lokal' };
    state.letztes.angebot.positionen = letztesSS.positionen || [];
    state.letztes.angebot.summen = letztesSS.summen || {};
    zeigeDone(state.letztes, [ok ? { text: 'Kopie an CILSON gesendet.', art: 'ok' } : { text: 'Kopie konnte nicht automatisch gesendet werden – Ihr PDF ist davon unabhängig.', art: '', mailto: true }]);
    if (E.dDown && !bytes) E.dDown.hidden = true;
    try { history.replaceState(null, '', location.pathname); } catch (e) { /* egal */ }
  }

  (function start() {
    var gespeichert = ssGet(SS_POS);
    if (Array.isArray(gespeichert)) state.positionen = gespeichert.filter(function (p) { return p && p.variant_id && p.handle; });
    ladeKunde();
    toggleAbw();
    renderAlles();
    if (state.positionen.length) auffrischen();
    doneWiederherstellen();

    var params;
    try { params = new URLSearchParams(location.search); } catch (e) { params = null; }
    if (!params) return;
    var add = params.get('add'), qty = Math.max(1, Math.round(zahl(params.get('qty'), 1))), h = params.get('h');
    if (add && /^\d+$/.test(add)) {
      posMeldung('Artikel wird übernommen …');
      var job = h && /^[a-z0-9-]+$/i.test(h) ? addByHandle(h, add, qty).catch(function () { return addByVariantId(add, qty); }) : addByVariantId(add, qty);
      job.then(function (p) { posMeldung(p.titel + (p.variante ? ' (' + p.variante + ')' : '') + ' übernommen.', 'ok'); })
        .catch(function () { posMeldung('Der Artikel von der Produktseite konnte nicht übernommen werden. Bitte suchen Sie ihn oben.', 'error'); });
    }
    if (params.get('from') === 'cart') warenkorbUebernehmen();
    if (add || params.get('from')) {
      try { history.replaceState(null, '', location.pathname); } catch (e) { /* egal */ }
    }
  })();
})();
